// extracted by mini-css-extract-plugin
export default {"section":"QualifierFormPage_section__sldO4","formWrapper":"QualifierFormPage_formWrapper__qP2s-","formWrapperError":"QualifierFormPage_formWrapperError__3NMen"};